import PropTypes from "prop-types";
import React, { useMemo } from "react";
import algoliasearch from "algoliasearch/lite";
import { Configure, InstantSearch, SearchBox, RefinementList } from "react-instantsearch";

import MediaOutletCardSkeleton from "./card/MediaOutletCardSkeleton";
import InfiniteHits from "./search/InfiniteHits";
import SearchToolbar from "../source_directory/SearchToolbar";
import FilterPill from "../source_directory/FilterPill";
import FilterClearEffect from "../source_directory/FilterClearEffect";
import sharedAlgoliaRouter from "../source_directory/sharedAlgoliaRouter";
import useSavedOnlyFilter from "../source_directory/useSavedOnlyFilter";
import useDebouncedQueryHook from "../source_directory/useDebouncedQueryHook";

function MediaOutletsSearch({
  algoliaAppId,
  algoliaSearchKey,
  indexName,
  viewMode,
  showFilters,
  onToggleFilters,
  savedOnly,
  onToggleSavedOnly,
  onViewModeChange,
  groupCount,
  onMyGroupsClick,
  showMyGroupsButton,
  showSavedToggle,
}) {
  const queryHook = useDebouncedQueryHook();
  const searchClient = useMemo(() => algoliasearch(algoliaAppId, algoliaSearchKey), [algoliaAppId, algoliaSearchKey]);
  const savedFilter = useSavedOnlyFilter(savedOnly, "Id::MediaOutlet");

  return (
    <div className="ais-InstantSearch">
      <InstantSearch
        indexName={indexName}
        searchClient={searchClient}
        routing={{ router: sharedAlgoliaRouter }}
        future={{ preserveSharedStateOnUnmount: true, cleanUrlOnDispose: false }}
      >
        <Configure maxValuesPerFacet={1000} filters={savedFilter ?? ""} />
        <FilterClearEffect showFilters={showFilters} />
        <SearchToolbar
          showFilters={showFilters}
          onToggleFilters={onToggleFilters}
          savedOnly={savedOnly}
          onToggleSavedOnly={onToggleSavedOnly}
          viewMode={viewMode}
          onViewModeChange={onViewModeChange}
          groupCount={groupCount}
          onMyGroupsClick={onMyGroupsClick}
          showMyGroupsButton={showMyGroupsButton}
          showSavedToggle={showSavedToggle}
        >
          <SearchBox autoFocus placeholder="Search" searchAsYouType queryHook={queryHook} />
        </SearchToolbar>

        <div
          className="sd-filter-row"
          style={{ display: showFilters ? "flex" : "none", flexWrap: "wrap", gap: 8, marginBottom: 12 }}
        >
          <FilterPill label="Tier" attribute="prestige">
            <RefinementList attribute="prestige" limit={10} />
          </FilterPill>
          <FilterPill label="Type" attribute="outlet_classification">
            <RefinementList attribute="outlet_classification" limit={10} />
          </FilterPill>
        </div>

        <InfiniteHits MediaOutletCardSkeleton={MediaOutletCardSkeleton} viewMode={viewMode} />
      </InstantSearch>
    </div>
  );
}

MediaOutletsSearch.propTypes = {
  algoliaAppId: PropTypes.string.isRequired,
  algoliaSearchKey: PropTypes.string.isRequired,
  indexName: PropTypes.string.isRequired,
  viewMode: PropTypes.oneOf(["grid", "list"]).isRequired,
  showFilters: PropTypes.bool.isRequired,
  onToggleFilters: PropTypes.func.isRequired,
  savedOnly: PropTypes.bool,
  onToggleSavedOnly: PropTypes.func.isRequired,
  onViewModeChange: PropTypes.func.isRequired,
  groupCount: PropTypes.number,
  onMyGroupsClick: PropTypes.func,
  showMyGroupsButton: PropTypes.bool,
  showSavedToggle: PropTypes.bool,
};

export default MediaOutletsSearch;
